import { exec, cd } from "shelljs";

export const getGitBranch = (directoryPath: string): string => {
    const startDir = process.cwd();
    cd(directoryPath);
    const currentBranch = exec("git rev-parse --abbrev-ref HEAD", { silent: true });
    cd(startDir);

    return currentBranch.toString();
};
